import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function Generate({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7266 14.3738L16.6328 17.2214C16.043 17.8113 15 17.3933 15 16.5574V14.9949H13.7891C13.6602 14.9949 13.5352 14.9402 13.4453 14.8425L9.9375 11.0457L11.4258 9.43239L14.543 12.8035H15V10.9285C15 10.0925 16.043 9.67457 16.6328 10.2644L19.7266 13.0379C20.0898 13.4129 20.0898 14.0066 19.7266 14.3738ZM0.46875 4.68629H4.05469L7.17188 8.05739L8.66016 6.4441L5.15234 2.64723C5.0625 2.54957 4.9375 2.49489 4.80859 2.49489H0.46875C0.210938 2.49489 0 2.70582 0 2.96364V4.21363C0 4.47535 0.210938 4.68629 0.46875 4.68629ZM19.7266 3.04957L16.6328 0.276135C16.043 -0.313709 15 0.10426 15 0.936292V2.49879H13.7891C13.6602 2.49879 13.5352 2.55348 13.4453 2.65114L4.05469 12.8113H0.46875C0.210938 12.8113 0 13.0222 0 13.28V14.53C0 14.7879 0.210938 14.9988 0.46875 14.9988H4.80469C4.93359 14.9988 5.05859 14.9441 5.14844 14.8464L14.5391 4.68629H15V6.56129C15 7.39723 16.043 7.8152 16.6328 7.22535L19.7266 4.37379C20.0898 4.0066 20.0898 3.41285 19.7266 3.04957Z"
        fill={color}
      />
    </svg>
  );
}
